
'use strict';

var novicell = novicell || {};
// Lazysizes config
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 1000;
window.lazySizesConfig.init = false;
window.lazySizesConfig.throttle = 70; //default: 125
window.lazySizesConfig.expFactor = 1.5; //default: 2
window.lazySizesConfig.loadMode = 3; //default 2



document.addEventListener('lazybeforeunveil', function(e){

    // IE Fix
    e.preventDefault = function () {
        Object.defineProperty(this, "defaultPrevented", {get: function () {return true;}});
    };


    var target = e.target;
    var preventLoad = target.classList.contains('lazyload-measure') || target.classList.contains('lazyload-bg'); 
    if(preventLoad) {
        e.preventDefault(); 

        var setBg = target.classList.contains('lazyload-bg');    
        var url = target.classList.contains('lazyload-measure') ? novicell.dynamicImage.getUrl(target) : target.dataset.src;
        if(setBg) {
            target.parentNode.style.backgroundImage = 'url(' + url + ')';       
        } else {
            target.src = url;
        }
    }
}, true);

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var lastRefreshWidth = 0;
var refreshWidth = 50;

var checkImages = debounce(function() {
    if (window.innerWidth > lastRefreshWidth + refreshWidth || window.innerWidth < lastRefreshWidth - refreshWidth) {
        var loadedElements = document.body.querySelectorAll('.lazyloaded');
        loadedElements.forEach(function(el){
            el.classList.remove('lazyloaded');
            el.classList.add('lazyload');
        });
        lastRefreshWidth = window.innerWidth;
    };
}, 100, false);

window.addEventListener('resize', checkImages);

